import Marquee from "react-fast-marquee";

export default function EditorialMarquee({ dark = false }) {
  const items = [
    "Dentainhoa",
    "Higiene a domicilio",
    "Bienestar",
    "Madrid",
    "Sin desplazamientos",
    "Protocolo clínico",
  ];
  return (
    <div data-testid="editorial-marquee" className={`py-10 md:py-16 marquee-wrap border-y ${dark ? "border-white/15 bg-[color:var(--bg-dark)]" : "border-[color:var(--border-subtle)]"}`}>
      <Marquee speed={34} gradient={false} pauseOnHover>
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className={`${dark ? "stroke-text-dark" : "stroke-text"} font-heading italic text-6xl md:text-8xl leading-none px-8`}
          >
            {t} &nbsp;·&nbsp;
          </span>
        ))}
      </Marquee>
    </div>
  );
}
